var _defs, _rect, _rect2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimizeNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-122{fill:#caccd0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 20.39,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 14.68,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "8.57 17.91 2.11 11.45 8.57 4.99 9.63 6.05 4.23 11.45 9.63 16.85 8.57 17.91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeNavIcon);
export default __webpack_public_path__ + "static/media/minimize_nav_Icon.464f24e5496a012704bd4d15c8479552.svg";
export { ForwardRef as ReactComponent };